import ApiClient from "@/ts/Utility/ApiClient";
import AudioGroup from "@/ts/Audio/AudioGroup";

export default class AudioRepository {
    public static async getAll(type: string): Promise<AudioGroup[]> {
        return await ApiClient.get<AudioGroup[]>(`v2/${type}`);
    }
    public static async saveMeditationListenedEvent(id: number): Promise<void> {
        try {
            await ApiClient.post<void>(`/meditations/${id}/listened`);
        }catch (e) {
        }
    }
}
